/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type SendMerchantAppLinkMutationVariables = {
    mobile: string;
};
export type SendMerchantAppLinkMutationResponse = {
    readonly sendMerchantAppLink: {
        readonly result: string | null;
    } | null;
};
export type SendMerchantAppLinkMutation = {
    readonly response: SendMerchantAppLinkMutationResponse;
    readonly variables: SendMerchantAppLinkMutationVariables;
};



/*
mutation SendMerchantAppLinkMutation(
  $mobile: String!
) {
  sendMerchantAppLink(mobile: $mobile) {
    result
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "mobile"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "mobile",
        "variableName": "mobile"
      }
    ],
    "concreteType": "SendMerchantAppLink",
    "kind": "LinkedField",
    "name": "sendMerchantAppLink",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SendMerchantAppLinkMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SendMerchantAppLinkMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "256d6ba064e77916338693662e816823",
    "id": null,
    "metadata": {},
    "name": "SendMerchantAppLinkMutation",
    "operationKind": "mutation",
    "text": "mutation SendMerchantAppLinkMutation(\n  $mobile: String!\n) {\n  sendMerchantAppLink(mobile: $mobile) {\n    result\n  }\n}\n"
  }
};
})();
(node as any).hash = '1ebf6aa40f6e529954ed04e44f501485';
export default node;
